import {
    APPOINTMENTS_LIST_ROUTE,
    CASES,
    CLIENT_INJURY_DETAILS_ROUTE,
    CLIENT_INJURY_SUCCESS_ROUTE,
    CLIENT_REGISTRATION_CONSENT_ROUTE,
    CLIENT_REGISTRATION_ROUTE,
    COMING_SOON_ROUTE,
    LOGIN_ROUTE,
    NOT_FOUND_ROUTE,
    ON_BOARDING_ROUTE,
    PROFILE_ROUTE,
    TEST_ROUTE,
    ACTIVITY_LOGS,
    OTHER_SHARED_DOCUMENTS_ROUTE,
    CASES_RECORD_DETAILS_ROUTE,
    PERFORMANCE_RECORDS_ROUTE,
    TRANSACTIONS_ROUTE,
    DASHBOARD_ROUTE,
    BOOK_APPOINTMENTS_ROUTE,
    CLIENT_RESOURCE_ROUTE, ADD_HEALTH_AND_RELEASE_ROUTE,
} from "../../constants/RoutesConfig";

const DefaultRoute = () => {
    return APPOINTMENTS_LIST_ROUTE;
}

const BookAppointmentRoute = () => {
    return BOOK_APPOINTMENTS_ROUTE;
}

const NotFoundRoute = () => {
    return NOT_FOUND_ROUTE;
}

const TestRoute = () => {
    return TEST_ROUTE;
}

const LoginRoute = () => {
    return LOGIN_ROUTE;
}

const ComingSoonRoute = () => {
    return COMING_SOON_ROUTE;
}

const ClientInjuryDetails = () => {
    return CLIENT_INJURY_DETAILS_ROUTE;
}

const ClientInjurySuccess = (context: 'injury-form' | 'client-registration') => {
    return CLIENT_INJURY_SUCCESS_ROUTE + "?context=" + context;
}

const ClientOnboarding = () => {
    return ON_BOARDING_ROUTE;
}

const ClientRegistration = () => {
    return CLIENT_REGISTRATION_ROUTE;
}

const ClientRegistrationConsent = () => {
    return CLIENT_REGISTRATION_CONSENT_ROUTE;
}

const AppointmentList = () => {
    return APPOINTMENTS_LIST_ROUTE;
}
const Dashboard = () => {
    return DASHBOARD_ROUTE;
}
const ClientResource = () => {
    return CLIENT_RESOURCE_ROUTE;
}

const ClientWaiverAndReleaseRoute = (id: string) => {
    return '/dashboard/' + id + '/waiver-and-release';
}

const AddClientWaiverAndReleaseRoute = () => {
    return '/dashboard/waiver-and-release';
}
const ClientDisclosureRoute = (id: string, appointmentId: string) => {
    return '/dashboard/' + id + '/disclosure-and-release/' + appointmentId;
}
const EditClientHealthReleaseRoute = (appointmentId: string) => {
    return '/dashboard/' + appointmentId + '/health-and-release';
}
const AddClientHealthReleaseRoute = () => {
    return ADD_HEALTH_AND_RELEASE_ROUTE
}

const AppointmentDetails = (appointmentId: string) => {
    return '/appointments/' + appointmentId;
}

const AppointmentInjuryDetailsScreen = (formId: string, status: string, appointmentId: string) => {
    return '/appointments/injury-details/' + formId + '/' + appointmentId + '?status=' + status;
}

const AppointmentInjuryDetailsAddScreen = (appointmentId?: string) => {
    return '/appointments/injury-details/add/' + appointmentId;
}
const AppointmentCertificationAnsConsentFormScreen = (formId: string, appointmentStatus: string, appointmentId: string) => {
    return '/appointments/certification-and-consent-form/' + formId + '/' + appointmentId + '?status=' + appointmentStatus;
}
const AppointmentCertificationAnsConsentFormAddScreen = (appointmentId?: string) => {
    return '/appointments/certification-and-consent-form/add/' + appointmentId;
}

const AppointmentAuthorizationToReleaseMedicalInformationScreen = (formId: string, appointmentStatus: string, appointmentId: string) => {
    return '/appointments/authorization-to-release-medical-information/' + formId + '/' + appointmentId + '?status=' + appointmentStatus;
}

const AppointmentAuthorizationToReleaseMedicalInformationAddScreen = (appointmentId?: string) => {
    return '/appointments/authorization-to-release-medical-information/add/' + appointmentId;
}
const ProfileLayout = () => {
    return PROFILE_ROUTE;
}

const ProfileDetails = () => {
    return PROFILE_ROUTE + '/details';
}

const ProfileMedicalHistoryDetails = () => {
    return PROFILE_ROUTE + '/medical-history-questionnaire';
}

const ProfilePreferencesDetails = () => {
    return PROFILE_ROUTE + '/preferences';
}

const ProfileLinking = () => {
    return PROFILE_ROUTE + '/linking';
};

const ProfileEdit = () => {
    return '/profile-edit';
}

const ClientCases = () => {
    return CASES;
}

const ClientActivityLog = () => {
    return ACTIVITY_LOGS;
}
const CaseDetails = (caseId: string) => {
    return CASES + "/" + caseId;
}

const OtherSharedDocuments = () => {
    return OTHER_SHARED_DOCUMENTS_ROUTE
}

const CasesRecordDetails = (recordId: string) => {
    return CASES_RECORD_DETAILS_ROUTE + '/' + recordId;
}

const PerformanceRecordViewDetails = (performanceRecordId: string) => {
    return PERFORMANCE_RECORDS_ROUTE + '/' + performanceRecordId;
}

const Transaction = () => {
    return TRANSACTIONS_ROUTE;
}

const TransactionDetails = (transactionId: string) => {
    return TRANSACTIONS_ROUTE + '/' + transactionId;
}

const RouteConfigService = {
    DefaultRoute,
    NotFoundRoute,
    TestRoute,
    ComingSoonRoute,
    ClientInjuryDetails,
    ClientInjurySuccess,
    LoginRoute,
    ClientOnboarding,
    ClientRegistration,
    ClientRegistrationConsent,
    ClientCases,
    CaseDetails,
    AppointmentList,
    AppointmentDetails,
    ProfileLayout,
    ProfileDetails,
    ProfileLinking,
    ProfileEdit,
    AppointmentInjuryDetailsScreen,
    AppointmentCertificationAnsConsentFormScreen,
    AppointmentAuthorizationToReleaseMedicalInformationScreen,
    AppointmentInjuryDetailsAddScreen,
    AppointmentCertificationAnsConsentFormAddScreen,
    AppointmentAuthorizationToReleaseMedicalInformationAddScreen,
    ClientActivityLog,
    ProfileMedicalHistoryDetails,
    ProfilePreferencesDetails,
    OtherSharedDocuments,
    CasesRecordDetails,
    PerformanceRecordViewDetails,
    Transaction,
    TransactionDetails,
    Dashboard,
    BookAppointmentRoute,
    ClientResource,
    ClientWaiverAndReleaseRoute,
    ClientDisclosureRoute,
    AddClientHealthReleaseRoute,
    EditClientHealthReleaseRoute,
    AddClientWaiverAndReleaseRoute

}

export default RouteConfigService;
